import { PortalMemberSummary } from "../../features/portal/models/PortalMe";

interface PortalMemberSwitcherProps {
  members: PortalMemberSummary[];
  selectedMemberId: string;
  onSelect: (memberId: string) => void;
}

/**
 * Chip row for a guardian to switch between their own record and their wards; the page's
 * `usePortalMember` turns a pick into `?member=`. Hidden entirely when there is only one member to show.
 */
const PortalMemberSwitcher = ({ members, selectedMemberId, onSelect }: PortalMemberSwitcherProps) => {
  if (members.length <= 1) {
    return null;
  }

  return (
    <div className="mb-4 flex flex-wrap gap-2">
      {members.map((member) => (
        <button
          key={member.memberId}
          type="button"
          aria-pressed={member.memberId === selectedMemberId}
          onClick={() => onSelect(member.memberId)}
          className={
            member.memberId === selectedMemberId
              ? "rounded-full bg-primary-40 px-4 py-1.5 text-sm font-medium text-white dark:bg-primary-90 dark:text-primary-10"
              : "rounded-full bg-grey-95 px-4 py-1.5 text-sm font-medium text-grey-20 hover:bg-grey-90 dark:bg-primary-20 dark:text-white dark:hover:bg-[#3E334D]"
          }
        >
          {member.firstName} {member.lastName}
        </button>
      ))}
    </div>
  );
};

export default PortalMemberSwitcher;
